import React from 'react';
import { BoxArrowUpRight, Calendar3, PeopleFill } from 'react-bootstrap-icons';
import AppBackButton from '../common/AppBackButton';
import './Dashboard.css';

/** Set `REACT_APP_WEBINAR_REGISTER_URL` in `.env` for production host registration. */
const WEBINAR_REGISTER_URL =
  process.env.REACT_APP_WEBINAR_REGISTER_URL?.trim() || 'https://www.linkedin.com/events/';

const WebinarRegistration: React.FC = () => {
  return (
    <div className="v1-dashboard-page v1-learning-detail-page v1-webinar-page">
      <main className="v1-dashboard-main v1-webinar-main">
        <AppBackButton />
        <article className="v1-card v1-webinar-card">
          <div className="v1-webinar-card-accent" aria-hidden />
          <div className="v1-webinar-card-inner">
            <p className="v1-webinar-eyebrow">Upcoming webinar</p>
            <h1 className="v1-webinar-title">Substation Design & Maintenance Best Practices</h1>
            <p className="v1-webinar-subtitle">
              Live session · Q&amp;A · Recording shared with registrants
            </p>

            <div className="v1-webinar-meta">
              <div className="v1-webinar-meta-tile">
                <Calendar3 className="v1-webinar-meta-ico" aria-hidden />
                <div>
                  <div className="v1-webinar-meta-label">When</div>
                  <div className="v1-webinar-meta-value">
                    Apr 10, 2026
                    <span className="v1-webinar-meta-sep">·</span>
                    1:00 PM EST
                  </div>
                </div>
              </div>
              <div className="v1-webinar-meta-tile">
                <PeopleFill className="v1-webinar-meta-ico" aria-hidden />
                <div>
                  <div className="v1-webinar-meta-label">Host</div>
                  <div className="v1-webinar-meta-value">PowerGrid Academy</div>
                </div>
              </div>
            </div>

            <p className="v1-webinar-body">
              Reserve your spot to learn practical design and maintenance patterns used in the
              field. You’ll receive a calendar invite and a link to join the live session.
            </p>

            <div className="v1-webinar-actions">
              <a
                href={WEBINAR_REGISTER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="v1-btn v1-btn-primary v1-btn-icon v1-webinar-cta v1-webinar-external-cta"
              >
                Proceed to register
                <BoxArrowUpRight className="v1-btn-lead-icon" aria-hidden />
              </a>
            </div>
          </div>
        </article>
      </main>
    </div>
  );
};

export default WebinarRegistration;
